<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">My Profile</h3>
            </div>
            <template>
              <v-form class="v-form-body" ref="form" v-model="valid" lazy-validation>
                <v-row>
                  <div class="card-profile-image">
                    <v-list>
                      <v-list-item>
                        <v-list-item-avatar color="#F0F0F0" size="110px">
                          <v-img v-if="media && media.length && media[0].url" :src="media[0].url"></v-img>
                          <span
                            v-else
                            color="#344452"
                            class="avatar-name display-4 font-weight-bold"
                          >{{ firstName.charAt(0).toUpperCase() }}</span>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <upload-avtar
                            :media="media"
                            @removeProfile="removeProfile"
                            @profileUrl="profileUrl"
                          ></upload-avtar>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                  <v-col cols="12">
                    <label class="form-control-label">
                      Email
                      <span class="red--text">*</span>
                    </label>
                    <v-text-field :value="email" readonly disabled solo></v-text-field>
                  </v-col>
                  <v-row class="mx-0">
                    <v-col cols="12" md="6">
                      <label class="form-control-label">
                        First Name
                        <span class="red--text">*</span>
                      </label>
                      <v-text-field
                        v-model="firstName"
                        :rules="[v => !!v || 'First name is required!']"
                        placeholder="First Name"
                        required
                        solo
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <label class="form-control-label">
                        Last Name
                        <span class="red--text">*</span>
                      </label>
                      <v-text-field
                        v-model="lastName"
                        :rules="[v => !!v || 'Last name is required!']"
                        placeholder="Last Name"
                        required
                        solo
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-col cols="12">
                    <label class="form-control-label">
                      About Me
                      <span class="red--text">*</span>
                    </label>
                    <v-textarea
                      v-model="bio"
                      solo
                      name="input-7-4"
                      :rules="[v => !!v || 'About Me is required!']"
                      placeholder="About Me"
                    ></v-textarea>
                  </v-col>
                  <v-col class="text-right" cols="12">
                    <v-btn
                      :disabled="!valid"
                      color="#344452"
                      class="white--text"
                      @click="validate"
                      :loading="loading"
                    >Update Profile</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </template>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { UserService } from "@/services";
import UploadAvtar from "@/components/UploadAvtar";

export default {
  name: "Profile",
  components: {
    UploadAvtar,
    CommonSection: () => import("@/components/CommonHeader"),
  },
  data() {
    return {
      loading: false,
      valid: true,
      firstName: "",
      lastName: "",
      email: "",
      bio: "",
      media: [],
    };
  },
  created() {
    this.profile();
  },
  methods: {
    profileUrl(response) {
      this.media = [];
      this.media.push(response);
      this.$bus.$emit('initializeHeader')
      this.$store.dispatch("user/setMedia", response);
    },
    removeProfile() {
      this.media = [];
      this.$bus.$emit('initializeHeader')
      this.$store.dispatch("user/removeMedia");
    },
    async profile() {
      const profile = await UserService.profile();
      this.firstName = profile.data.firstName;
      this.lastName = profile.data.lastName;
      this.bio = profile.data.bio;
      this.email = profile.data.email;
      this.media = profile.data.media;
    },
    async validate() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const response = await UserService.updateProfile({
          firstName: this.firstName,
          lastName: this.lastName,
          bio: this.bio,
        });
        if (response) {
          this.$store.dispatch(
            "user/setSnack",
            "Profile information updated successfully.!"
          );
          this.$store.dispatch("user/setType", "info");
          this.loading = false;
        }
        this.loading = false;
      }
    },
  },
};
</script>
